import React from "react";
import Container from "../ui/Container";
import SectionHeading from "../ui/SectionHeading";
import GlassCard from "../ui/GlassCard";
import SmartImage from "../ui/SmartImage";
import { coreServices } from "../../data/coreServices";

const CoreServices = () => (
  <section id="core-services" className="bg-surface-container-lowest py-20 md:py-section-gap">
    <Container>
      <SectionHeading
        align="center"
        title="Our Core Freight Services"
        className="mb-16"
      />
      <div className="grid grid-cols-1 gap-8 md:grid-cols-3">
        {coreServices.map((service) => (
          <GlassCard key={service.title} className="flex flex-col overflow-hidden">
            <SmartImage
              src={service.image}
              alt={service.alt}
              wrapperClassName="h-64 rounded-t-2xl"
              className="h-full w-full object-cover transition-transform duration-500 hover:scale-110"
            />
            <div className="flex flex-grow flex-col p-8">
              <h3 className="mb-4 font-headline-lg text-headline-lg text-primary">
                {service.title}
              </h3>
              <p className="flex-grow font-body-md text-body-md text-on-surface-variant">
                {service.description}
              </p>
            </div>
          </GlassCard>
        ))}
      </div>
    </Container>
  </section>
);

export default CoreServices;
